import {
  cardinalForCompassOffset,
  compassOffsetForCardinal,
  compassOffsetForOutwardNormal,
  exposureForCompassOffset
} from '@alpinehomeair/common';
import { ExposureDirectionType, PositionType } from 'data/types';
import { EdgeRunType, OpeningEdgeType } from 'utils/opening-position-types';

export function exposureForOutwardNormal(
  outward: PositionType,
  structureOrientation: ExposureDirectionType | undefined
): ExposureDirectionType {
  return exposureForCompassOffset(
    compassOffsetForOutwardNormal(outward),
    structureOrientation
  );
}

export function edgeForOutwardNormal(outward: PositionType): OpeningEdgeType {
  return cardinalForCompassOffset(compassOffsetForOutwardNormal(outward));
}

export function exposureForEdgeRun(
  run: Pick<EdgeRunType, 'edge' | 'outward'>,
  structureOrientation: ExposureDirectionType | undefined
): ExposureDirectionType {
  const offset = run.outward
    ? compassOffsetForOutwardNormal(run.outward)
    : compassOffsetForCardinal(run.edge);
  return exposureForCompassOffset(offset, structureOrientation);
}
